import { useEffect, useState } from 'react';
import { IOnlinePreferredTourCategory } from '../utils/types';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from '@mui/material';
import { ChevronRightTwoTone } from '@mui/icons-material';
import { onlineTourPreferredCategories } from '../api';
import { LinkBehavior } from '../components/LinkBehavior';

export function FeaturedTourCategories() {
  const [data, setData] = useState<IOnlinePreferredTourCategory[]>();

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    try {
      const preferredToursCategories = await onlineTourPreferredCategories(
        true,
      );
      if (preferredToursCategories.ok) {
        const data = await preferredToursCategories.json();
        setData(data);
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  return (
    <Grid container spacing={2} justifyContent="center">
      {data
        ?.sort((a, b) => a.order - b.order)
        .map((tour: IOnlinePreferredTourCategory, index: number) => (
          <Grid item xs={12} md={4} lg={3} key={index}>
            <CategoryCard key={index} tour={tour} />
          </Grid>
        ))}
    </Grid>
  );
}

const CategoryCard = ({ tour }: { tour: IOnlinePreferredTourCategory }) => {
  const { t } = useTranslation();

  const price = tour.price?.toLocaleString('tr-TR', {
    style: 'currency',
    currency: tour.currencyCode,
    maximumFractionDigits: 0,
  });

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardMedia>
        <img
          src={tour.imagePath}
          alt={tour.name}
          style={{ width: '100%', height: 170, objectFit: 'cover' }}
        />
      </CardMedia>
      <CardContent sx={{ flex: 1 }}>
        <Typography variant="h5">{tour.name}</Typography>
        <Typography sx={{ mt: 1 }} color="GrayText">
          {tour.description}
        </Typography>
      </CardContent>
      <CardActions sx={{ borderTop: '1px solid #EAEAEA' }}>
        <Button
          fullWidth
          href={`/tours?categories=${tour.id}`}
          LinkComponent={LinkBehavior}
        >
          <Box display="flex" alignItems="center">
            <Typography
              sx={{
                color: 'primary.main',
                fontWeight: 'bold',
                fontSize: '20px',
              }}
            >
              {price}
            </Typography>
            <Typography
              sx={{ color: '#A5A5A5', fontWeight: '500', fontSize: '17px' }}
            >
              {t('featuredTourCategories.pricesStartingFrom')}
            </Typography>
            <ChevronRightTwoTone />
          </Box>
        </Button>
      </CardActions>
    </Card>
  );
};
